import { Modal, Text } from '@pinchenterprisesnpm/friday-ui'
import { InviteUpshiftersContent } from '@src/features/shift-post-v2/steps/invite-upshifters-step/components/invite-upshifters-section/components/invite-upshifters-content/invite-upshifters-content'
import { ScrollableModalContent } from '@src/ui/components/common/style'

const { Header } = Modal

interface IInvitationSummaryModalProps {
  isOpen: boolean
  closeModal: () => void
}

export const InvitationSummaryModal = ({ isOpen, closeModal }: IInvitationSummaryModalProps) => {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} width='800px' height='600px'>
      <Header title='Invitation Summary' />

      <ScrollableModalContent>
        <Text my='sm'>
          Send personalised invites exclusively to Upshifters you`ve previously worked with. They`ll
          have priority access for the next 12 hours.
        </Text>

        <InviteUpshiftersContent isConfirmStep />
      </ScrollableModalContent>
    </Modal>
  )
}
